import { capitalizeText } from '../../../helpers/utils';

interface ICategoryProps {
  name: string;
  image: string;
}
interface ITabsOrderProps {
  selected?: ICategoryProps;
  categories: {
    name: string;
    image: string;
    total?: number;
  }[];
  handleClick: (val: ICategoryProps) => void;
  textClassName?: string;
}
const TabsOrder = ({ selected, categories, handleClick, textClassName }: ITabsOrderProps) => {
  return (
    <div className="flex flex-col bg-white p-auto">
      <div className="flex overflow-x-scroll pb-5 hide-scroll-bar">
        <div className="flex flex-nowrap">
          {categories.map((category, index) => {
            return (
              <div
                key={index}
                id={category.name}
                className="inline-block pr-3 cursor-pointer"
                onClick={() => handleClick(category)}
              >
                <div
                  className={`${textClassName} leading-6 max-w-full whitespace-nowrap font-medium text-center p-2 text-reliableBlack overflow-hidden border border-reliableBlack10 rounded-lg hover:bg-[#FFE9E9] hover:border-supportiveRed hover:text-supportiveRed transition-shadow duration-300 ease-in-out ${selected.name === category.name && 'text-supportiveRed border-supportiveRed bg-[#FFE9E9]'}`}
                >
                  {capitalizeText(category.name)}{' '}
                  {selected.name === category.name && (
                    <span className="inline-flex items-center justify-center rounded-full ml-2 bg-supportiveRed text-white min-w-[1.50rem] min-h-[1.50rem] max-w-auto max-h-auto shrink-0 grow-0 font-light">
                      {category?.total}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TabsOrder;
